import { createSelector } from '@ngrx/store';

import { selectIsStateLoading, selectResult, selectResultOrEmptyArray } from '../../shared/utils';
import { authFeature } from './auth.feature';

export const { selectAvailableProfiles, selectActiveProfile } = authFeature;

export const selectActiveUserProfile = createSelector(selectActiveProfile, selectResult);
export const selectAvailableUserProfiles = createSelector(selectAvailableProfiles, selectResultOrEmptyArray);
export const selectAvailableUserProfilesLoading = createSelector(selectAvailableProfiles, selectIsStateLoading);

export const selectActiveUserOrganizationId = createSelector(
    selectActiveUserProfile,
    (userProfile) => userProfile?.organizationId ?? null,
);
export const selectActiveUserTenantId = createSelector(selectActiveUserProfile, (userProfile) => userProfile?.tenantId);

export const selectCurrentTenantAndOrganizationId = <T>(query: T) => {
    return createSelector(selectActiveUserProfile, (userProfile) => {
        return userProfile && userProfile.tenantId && userProfile.organizationId
            ? {
                  tenantId: userProfile.tenantId,
                  organizationId: userProfile.organizationId,
                  query,
              }
            : null;
    });
};
export const selectCurrentOrganizationId = createSelector(
    selectActiveUserProfile,
    (userProfile) => userProfile?.organizationId,
);
